"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var defaultState = {
    isDark: false,
    toggleDark: function () { return undefined; }
};
exports.ThemeManagerContext = react_2.createContext(defaultState);
var supportsDarkMode = function () {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
};
exports.ThemeManagerProvider = function (props) {
    var _a = react_2.useState(false), isDark = _a[0], setIsDark = _a[1];
    var toggleDark = function (value) {
        var toggledTheme = (value !== null && value !== void 0 ? value : !isDark);
        setIsDark(toggledTheme);
        localStorage.setItem("dark", JSON.stringify(toggledTheme));
    };
    react_2.useEffect(function () {
        var themeFromLocalStorage = localStorage.getItem("dark");
        if (typeof themeFromLocalStorage === 'string') {
            setIsDark(JSON.parse(themeFromLocalStorage));
        }
        else if (supportsDarkMode()) {
            setIsDark(true);
        }
    }, []);
    return (react_1.default.createElement(exports.ThemeManagerContext.Provider, { value: {
            isDark: isDark,
            toggleDark: toggleDark
        } }, props.children));
};
//# sourceMappingURL=ThemeManager.js.map